import React, { useState, useEffect } from "react";


let valuesdata = [];
let hasfilter = "";

const CustomSelect = ({
  defaultText,
  item,
  // filterOptions,
  onSearch,
  setStartPage,
  openDropdown,
  handleDropdownToggle,
  handleValueSelect,
  filter,
  setFilters,
  ceid
}) => {
  const [defaultSelectText, setDefaultSelectText] = useState(defaultText);
  const [defaultSelectId, setDefaultSelectId] = useState(defaultText);
  // const [filters, setFilters] = useState({});
  const [showOptionList, setShowOptionList] = useState(false);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        !e.target.classList.contains("custom-select-option") &&
        !e.target.classList.contains("selected-text")
      ) {
        setShowOptionList(false);
        let values = {}
        // onSearch(values,hasfilter)
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowOptionList]);

  // const handleListDisplay = () => {
  //   setShowOptionList((prevShowOptionList) => !prevShowOptionList);
  // };

  const handleOptionClick = (e, item) => {
    hasfilter = true
    const selectedValue = e.target.getAttribute("data-name");
    const selectedValueId = e.target.getAttribute("data-id");
    const selectedDataFiled = e.target.getAttribute("data-filed")

    let newFilters = { ...filter };
    if (
      selectedValueId === 'A' || selectedValueId === 'C' || selectedValueId === 'NC' || selectedValueId === "RP") {
      newFilters.claimType = selectedValueId
    }
    else if (
      selectedValueId === 'DL' || selectedValueId === 'WL' || selectedValueId === "BI" || selectedValueId === "ML" || selectedValueId ==="QL") {
      newFilters.frequency = selectedValueId
    }

    else if (selectedValueId == "1010" || selectedValueId == "1020" ||selectedValueId == '1030' || selectedValueId == '1040' || selectedValueId == '1050' || selectedValueId == '1060' || selectedValueId == '1070') {
      newFilters.status = selectedValueId
    }
    setFilters(newFilters);
    setStartPage(2);
    if (ceid) {
      onSearch(newFilters, hasfilter);
    }
    handleValueSelect(item.filterdataFiled, selectedValue);
    handleDropdownToggle(null)
    setDefaultSelectText(item.filterName, selectedValue);
    setDefaultSelectId(selectedValueId)
    setShowOptionList(false);
  };
  const handleListDisplay = () => {
    handleDropdownToggle(item.filterdataFiled)
  };

  useEffect(() => {
    setShowOptionList(openDropdown === item.filterdataFiled);
  }, [openDropdown]);

  return (
    <div className="custom-select-container">
      <div onClick={handleListDisplay}
        className={showOptionList ? "selected-text active" : "selected-text"}
      >
        {/* {defaultSelectText} */}
        {defaultText}
        <div>
        </div>
      </div>
      {showOptionList && (
        <ul className="select-options">
          {item.filterOptions.map((option) => {
            return (
              <li
                className="custom-select-option"
                data-id={option.id}
                data-name={option.label}
                key={option.id}
                data-filed={item.filterdataFiled}
                onClick={(e) => {
                  handleOptionClick(e, item)
                }}
              >
                {option.label}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;
